import PropTypes from 'prop-types'

import styles from './styles/Checkbox.css'

export function Checkbox ({ checked, className, ...rest }) {
  return <input className={`fa fa-lg fa-check ${styles.checkbox} ${className || ''}`} type='checkbox' checked={checked} {...rest} />
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string
}

export default Checkbox
